import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47be4c31"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-campaign-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_UserUpIcon = _resolveComponent("UserUpIcon");
  const _component_TagIcon = _resolveComponent("TagIcon");
  const _component_PpcBudgetAllocationWeeklyBudgetCampaignBody = _resolveComponent("PpcBudgetAllocationWeeklyBudgetCampaignBody");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ba-campaign", $options.getClass()])
  }, [_createElementVNode("div", _hoisted_1, [$options.getClass() == 'product' ? (_openBlock(), _createBlock(_component_UserUpIcon, {
    key: 0
  })) : (_openBlock(), _createBlock(_component_TagIcon, {
    key: 1
  })), _createTextVNode(" " + _toDisplayString($options.getTitle()), 1)]), _createVNode(_component_PpcBudgetAllocationWeeklyBudgetCampaignBody, {
    data: $props.item,
    country_code: $props.country_code,
    currency: $props.currency,
    budgetCurrent: $props.item.budgetCurrent,
    potential: $props.item.potential,
    advanced: "",
    style: {
      "padding": "16px"
    },
    onUpdate: $options.onInputUpdate
  }, null, 8, ["data", "country_code", "currency", "budgetCurrent", "potential", "onUpdate"])], 2);
}